// extracted by mini-css-extract-plugin
module.exports = {"a15wtz6b":"a15wtz6b","active":"active"};